<template>
    <div class="infor fl">
        <all-header
            :label="lable"
            :ischage="ischage"
            :sublabel="sublabel"
            :subtitle="subtitle"
            @getvalue="getvalue"></all-header>
        <div v-if="list && step > 0  && activeAward.award_id != 17 && activeAward.award_id != 13" class="stepContainer">
            <div v-for="(item, index) in list" :key="index">
                <div class="stepcone">
                    <div
                        v-if="(index <= list.length - 1 ) "
                        class="line"
                        :style="{ width: (10 - list.length) * 48 + '%' }"></div>
                    <div
                        class="stepItem"
                        :class="{
                            isactibe: item.success,
                            stponce: step == index,
                            error: isFail == 'fail' && step == 3 && index == step,
                        }">
                        <i
                            v-if="index + 1 < list.length && step != index"
                            class="el-icon-check"
                            style="color: white"></i>
                        <span v-if="index + 1 < list.length && step == index">{{
                            index + 1
                        }}</span>
                        <img
                            v-if="step != 3 && index + 1 == list.length"
                            src="../assets/np18.png">
                        <img
                            v-if="step == 3 && index + 1 == list.length"
                            src="../assets/18.png">
                        <img
                            v-if="step == index"
                            src="../assets/down.png"
                            alt
                            class="downpng">
                    </div>

                    <span
                        v-if="isFail == 'fail' && step == 3 && index == step"
                        class="erroritem stepTitle">审核不通过</span>
                    <span
                        v-else
                        class="stepTitle"
                        :class="{
                            successtitle: item.success,
                            stpotitle: step == index,
                            erroritem: item.error,
                        }">{{ item.title }}</span>
                </div>
            </div>


        </div>
         <div v-if="list && step > 0  && activeAward.award_id == 17" class="stepContainer 2">
            <div v-for="(item, index) in list" :key="index">
                <div class="stepcone">
                    <div
                        v-if="(index <= list.length - 1 ) "
                        class="line"
                        :style="{ width: (10 - list.length) * 48 + '%' }"></div>
                    <div
                        class="stepItem"
                        :class="{
                            isactibe: item.success,
                            stponce: rstep == index,
                            error: isFail == 'fail' && rstep == 2 && index == rstep,
                        }">
                        <i
                            v-if="index + 1 < list.length && rstep != index"
                            class="el-icon-check"
                            style="color: white"></i>
                        <span v-if="index + 1 < list.length && rstep == index">{{
                            index + 1
                        }}</span>
                        <img
                            v-if="rstep != 3 && index + 1 == list.length"
                            src="../assets/np18.png">
                        <img
                            v-if="rstep == 3 && index + 1 == list.length"
                            src="../assets/18.png">
                        <img
                            v-if="rstep == index"
                            src="../assets/down.png"
                            alt
                            class="downpng">
                    </div>

                    <span
                        v-if="isFail == 'fail' && rstep == 1 && index == rstep"
                        class="erroritem stepTitle">审核不通过</span>
                    <span
                        v-else
                        class="stepTitle"
                        :class="{
                            successtitle: item.success,
                            stpotitle: rstep == index,
                            erroritem: item.error,
                        }">{{ item.title }}</span>

                </div>
            </div>


        </div>
        <div v-if="list && step > 0  && activeAward.award_id == 13" class="stepContainer 2">
        {{step}}
            <div v-for="(item, index) in list" :key="index">
                <div class="stepcone">
                    <div
                        v-if="(index <= list.length - 1 ) "
                        class="line"
                        :style="{ width: (10 - list.length) * 48 + '%' }"></div>
                    <div
                        class="stepItem"
                        :class="{
                            isactibe: item.success,
                            stponce: rstep == index,
                            error: isFail == 'fail' && rstep == 2 && index == rstep,
                        }">
                        <i
                            v-if="index + 1 < list.length && rstep != index"
                            class="el-icon-check"
                            style="color: white"></i>
                        <span v-if="index + 1 < list.length && rstep == index">{{
                            index + 1
                        }}</span>
                        <img
                            v-if="rstep != 3 && index + 1 == list.length"
                            src="../assets/np18.png">
                        <img
                            v-if="rstep == 3 && index + 1 == list.length"
                            src="../assets/18.png">
                        <img
                            v-if="rstep == index"
                            src="../assets/down.png"
                            alt
                            class="downpng">
                    </div>

                    <span
                        v-if="isFail == 'fail' && rstep == 1 && index == rstep"
                        class="erroritem stepTitle">审核不通过</span>
                    <span
                        v-else
                        class="stepTitle"
                        :class="{
                            successtitle: item.success,
                            stpotitle: rstep == index,
                            erroritem: item.error,
                        }">{{ item.title }}</span>

                </div>
            </div>


        </div>
        <div v-if="step == -1" class="block-list">
            <div
                v-for="(item, index) in awardList"
                :key="index"
                class="block-list-item">
                <div class="block-list-item-r-t">
                    {{item.level}}
                </div>
                <div class="block-list-item-box">
                    <div class="block-list-item-box-t">
                        {{ item.title }}
                    </div>
                    <div class="block-list-item-box-startend">
                        共{{ item.count }}条记录
                    </div>
                </div>
                <div
                    class="block-list-item-box-b"
                    @click="awardrecordList(1,item.id,item.title)">
                    申报记录
                </div>
            </div>
        </div>
        <div v-if="step == 0" ref="pdf">
            <div>
                <el-table
                    :data="recordlist"
                    :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
                    style="width: 100%; margin-top: 30px">
                    <el-table-column v-if="currentId == 17" :show-overflow-tooltip="true" min-width="110" prop="statustext" label="状态">
                    </el-table-column>
                    <el-table-column v-if="currentId == 21" :show-overflow-tooltip="true" min-width="100" prop="statustext" label="审核状态">
                    </el-table-column>
                    <el-table-column v-if="currentId == 13" :show-overflow-tooltip="true" min-width="100" prop="statustext" label="审核状态">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" label="申报批次" min-width="80">
                        <template slot-scope="scope">
                            <span>{{ scope.row.award_batch.year}}-{{ scope.row.award_batch.batch}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="award.title" label="申报项目" show-overflow-tooltip min-width="160">
                    </el-table-column>
                    <el-table-column v-if=" currentId == 15" :show-overflow-tooltip="true" label="申报人" min-width="100">
                         <template slot-scope="scope">
                            <span>{{ scope.row.content.candidate == undefined ? '' : scope.row.content.candidate.msg1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if=" currentId == 14" :show-overflow-tooltip="true" label="联系人" min-width="100">
                         <template slot-scope="scope">
                            <span>{{ scope.row.content.essinfo == undefined ? '' : scope.row.content.essinfo.linker }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if=" currentId == 14" :show-overflow-tooltip="true" label="联系电话" min-width="100">
                         <template slot-scope="scope">
                            <span>{{ scope.row.content.essinfo == undefined ? '' : scope.row.content.essinfo.tel }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if=" currentId == 13" :show-overflow-tooltip="true" label="联系人" min-width="100">
                         <template slot-scope="scope">
                            <span>{{ scope.row.content.info == undefined ? '' : scope.row.content.info.linker }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if=" currentId == 13" :show-overflow-tooltip="true" label="联系电话" min-width="100">
                         <template slot-scope="scope">
                            <span>{{ scope.row.content.info == undefined ? '' : scope.row.content.info.tel }}</span>
                        </template>
                    </el-table-column>
                     <el-table-column v-if=" currentId == 15" :show-overflow-tooltip="true" label="身份证号" min-width="100">
                         <template slot-scope="scope">
                            <span>{{ scope.row.content.candidate == undefined ? '' : scope.row.content.candidate.id_card }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if=" currentId == 15" :show-overflow-tooltip="true" label="工程项目名称" min-width="130">
                         <template slot-scope="scope">
                            <span>{{ scope.row.content.Typicaldeeds  == undefined ? '' : scope.row.content.Typicaldeeds.msg1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if=" currentId == 13" :show-overflow-tooltip="true" label="工程名称" min-width="130">
                        <template slot-scope="scope">
                            <span>{{ scope.row.content.info.msg1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="currentId == 21 || currentId == 12 || currentId == 9" :show-overflow-tooltip="true" label="工法名称" min-width="130">
                        <template slot-scope="scope">
                            <span v-if="scope.row.award_id==12 || scope.row.award_id==21 ">{{ scope.row.content.info.name }}</span>
                            <span v-else-if="scope.row.award_id==9&&scope.row.content!=null&&scope.row.content.Contractorinfo!=null">{{ scope.row.content.Contractorinfo.projectNname }}</span>
                            <span v-else-if="scope.row.award_id==13">{{ scope.row.content.info.msg1 }}</span>
                            <span v-else></span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if=" currentId == 21 || currentId == 12 || currentId == 9" :show-overflow-tooltip="true" label="编写单位" min-width="160">
                        <template slot-scope="scope">
                            <span v-if="scope.row.content!=null&&scope.row.content.info!=null">{{ scope.row.content.info.unit }}</span>
                            <span v-else></span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="currentId == 21 || currentId == 12 || currentId == 9" :show-overflow-tooltip="true" label="工法完成人" min-width="280">
                        <template slot-scope="scope">
                            <span v-if="scope.row.award_id==12 || scope.row.award_id==21"><span v-for="(author,index) in scope.row.content.info.author_names" :key="index">{{ author.name }}<span v-if="index + 1 < scope.row.content.info.author_names.length">、</span></span></span>
                            <span v-else-if="scope.row.award_id==9&&scope.row.content!=null&&scope.row.content.Contractorinfo!=null">{{ scope.row.content.Contractorinfo.projectNname }}</span>
                            <span v-else-if="scope.row.award_id==13">{{ scope.row.content.info.msg1 }}</span>
                            <span v-else></span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="currentId == 17"  :show-overflow-tooltip="true" prop="content.company" label="企业名称" min-width="150">
                    </el-table-column>
                    <el-table-column   v-if="currentId == 17" :show-overflow-tooltip="true" prop="content.group" label="小组名称" min-width="150">
                    </el-table-column>
                    <el-table-column   v-if="currentId == 17" :show-overflow-tooltip="true" prop="content.project_title" label="课题名称" min-width="150">
                    </el-table-column>
                    <el-table-column   v-if="currentId == 17" :show-overflow-tooltip="true" prop="content.project_type" label="课题类型" min-width="150">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="created_at" label="申报时间" min-width="150">
                    </el-table-column>
                    <el-table-column v-if="currentId != 21 && currentId != 17 && currentId != 13" :show-overflow-tooltip="true" min-width="100" prop="statustext" label="审核状态">
                    </el-table-column>
                    <el-table-column v-if="currentId == 21" :show-overflow-tooltip="true" min-width="180" label="办理提示">
                        <template slot-scope="scope">
                            <div class="gongfa-record-hints" v-if="scope.row.gongfaState">
                                <el-tag v-if="scope.row.gongfaState.withdrawText" type="warning" size="mini">{{ scope.row.gongfaState.withdrawText }}</el-tag>
                                <el-tag v-if="scope.row.gongfaState.modifyText" type="danger" size="mini">{{ scope.row.gongfaState.modifyText }}</el-tag>
                                <el-tag v-if="scope.row.gongfaState.smsFailedText" type="danger" size="mini">{{ scope.row.gongfaState.smsFailedText }}</el-tag>
                                <span v-if="!scope.row.gongfaState.withdrawText && !scope.row.gongfaState.modifyText && !scope.row.gongfaState.smsFailedText">—</span>
                            </div>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                    <!-- 公示状态列（除工程建设质量管理小组竞赛活动外保留） -->
                    <el-table-column v-if="currentId != 17 && currentId != 13" :show-overflow-tooltip="true" min-width="110" label="公示状态">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === 5" type="danger" size="mini">审核不通过</el-tag>
                            <el-tag v-else-if="scope.row.has_pending_modify" type="warning" size="mini">申请修改中</el-tag>
                            <el-tag v-else-if="scope.row.publicity_status===6" type="warning" size="mini">待确认信息</el-tag>
                            <el-tag v-else-if="scope.row.publicity_status===7 && scope.row.is_out==1" type="info" size="mini">审核完成</el-tag>
                            <el-tag v-else-if="scope.row.publicity_status===7 && scope.row.is_out!=1" type="success" size="mini">已确认</el-tag>
                            <el-tag v-else-if="scope.row.publicity_status===8" type="success" size="mini">已发证</el-tag>
                            <el-tag v-else-if="scope.row.publicity_status===9" type="primary" size="mini">申请修改已通过</el-tag>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        prop="operation"
                        :width="operationColumnWidth"
                        label="操作">
                        <template slot-scope="scope">
                            <div :class="['operation-btns', { 'operation-btns--nowrap': scope.row.award_id == 21 }]">
                                <el-button
                                    v-if="scope.row.award_id != 21"
                                    size="mini"
                                    type="text"
                                    @click="detail(scope.row.id, scope.row.status, scope.row.award.title, scope.row.file_urls, scope.row.content)">
                                    {{ scope.row.operation }}
                                </el-button>
                                <el-button
                                    v-if="scope.row.award_id==13&&scope.row.status==4&&!scope.row.file_urls"
                                    size="mini"
                                    type="text"
                                    @click="Appendix(scope.row.content.info.msg1, scope.row.id)">
                                    传附件
                                </el-button>
                                <el-button
                                    v-if="scope.row.award_id==9"
                                    size="mini"
                                    type="text"
                                    @click="openUpload(scope.row.id)">
                                    补充材料
                                </el-button>
                                <el-button
                                    v-if="canResubmit(scope.row)"
                                    size="mini"
                                    type="danger"
                                    @click="reSubmit(scope.row)">
                                    重提
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="openLog(scope.row)">
                                    日志
                                </el-button>
                                <el-button
                                    v-if="scope.row.award_id==21"
                                    size="mini"
                                    type="text"
                                    @click="openGongfaDetail(scope.row)">
                                    详情
                                </el-button>
                                <el-button
                                    v-if="canWithdraw(scope.row)"
                                    size="mini"
                                    class="withdraw-btn"
                                    @click="withdrawGongfa(scope.row)">
                                    撤回
                                </el-button>
                                <el-button
                                    v-if="scope.row.publicity_status===6 && !scope.row.has_pending_modify"
                                    size="mini"
                                    type="warning"
                                    @click="goPublicity(scope.row)">
                                    确认信息
                                </el-button>
                                <el-button
                                    v-if="scope.row.publicity_status===8"
                                    size="mini"
                                    type="success"
                                    @click="openCertDownload(scope.row)">
                                    获取证书
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 证书下载弹窗 -->
                <el-dialog title="获取证书" :visible.sync="certDownloadVisible" width="420px">
                    <div class="download-form" style="padding:10px 20px">
                        <p style="color:#666; margin-bottom:16px;">请验证手机号后下载正式证书（24小时内最多3次）</p>
                        <el-form :model="dlForm" label-width="80px">
                            <el-form-item label="手机号">
                                <el-input v-model="dlForm.phone" placeholder="请输入手机号" maxlength="11" />
                            </el-form-item>
                            <el-form-item label="验证码">
                                <div style="display:flex;gap:8px">
                                    <el-input v-model="dlForm.sms_code" placeholder="验证码" maxlength="6" style="flex:1"/>
                                    <el-button :disabled="smsCountdown>0" @click="sendDlSms" style="width:110px">
                                        {{ smsCountdown>0 ? `${smsCountdown}s后重试` : '发送验证码' }}
                                    </el-button>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <span slot="footer">
                        <el-button @click="certDownloadVisible=false">取消</el-button>
                        <el-button type="primary" :loading="dlLoading" @click="doCertDownload">下载证书</el-button>
                    </span>
                </el-dialog>
                <pagetion
                    :total="total"
                    class="pos-page"
                    @getpageValue="getpageValue"></pagetion>
            </div>
            <el-dialog title="上传补充材料" :visible.sync="dialogUploadVisible" :center="true" :before-close="handleClose">
                <div class="form_1">
                    <div class="form_box_content">
                        <div class="my_form2">
                            <div class="form_title" style="height: 62px">
                                材料名称
                            </div>
                            <div class="form_long">
                                <input v-model="supplementName" placeholder="请输入" type="text">
                            </div>
                        </div>
                        <div class="my_form">
                            <div class="form_title" style="height: 93px">
                                上传附件
                            </div>
                            <div class="form_long">
                                <el-upload
                                    class="upload-demo2"
                                    :action="$baseURL + '/api/home/upload/file/award_log'"
                                    :on-preview="handlesupplementPreview"
                                    :data="{ token: token }"
                                    accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
                                    :on-remove="handlesupplementRemove"
                                    :file-list="filesupplementList"
                                    :on-success="handlesupplementAdd"
                                    :on-error="handlesupplementError"
                                    list-type="text"
                                    :limit="1">
                                    <el-button
                                        size="small"
                                        icon="el-icon-upload2"
                                        style="color: #194abe">
                                        点击选择文件
                                    </el-button>
                                    <div slot="tip" class="el-upload__tip">
                                        {{ filesupplementList.length==0?'仅支持doc,docx,xls,xlsx,ppt,zip,rar格式，大小不超过50mb':'' }}
                                    </div>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="supplementClose">取消</el-button>
                    <el-button type="primary" @click="supplementSubmit">确认</el-button>
                </span>
            </el-dialog>
        </div>
        <div v-if="step == 1">
            <lineconbgtir :labelcontainer="labelcontainertow"></lineconbgtir>
            <div class="infor-c">
                中天城投集团是全省唯一一家房地产上市公司，中天城投集团是贵州省两个具有壹级开发资质的企业之一，无论土地资源储备、开发规模、资金实力，还是企业影响力、治理结构、管理基础，始终保持贵州省内房地产行业龙头企业的地位，是贵州省的房地产著名品牌。
                二十余年来，中天城投集团以超前的意识、敏锐的目光，通过所开发的四代住宅小区的示范效应，形成了在贵州具有广泛影响力的中天住宅品牌。成功开发中天花园、中天·世纪新城、中天会展城等项目，同时涵盖物业、健身、教育等产业，并且这些产业都是有口皆碑的。现在中天中天城投集团着重开发未来方舟这个超级大盘。中天城投集团是全省唯一一家房地产上市公司，中天城投集团是贵州省两个具有壹级开发资质的企业之一，无论土地资源储备、开发规模、资金实力，还是企业影响力、治理结构、管理基础，始终保持贵州省内房地产行业龙头企业的地位，是贵州省的房地产著名品牌。
                二十余年来，中天城投集团以超前的意识、敏锐的目光，通过所开发的四代住宅小区的示范效应，形成了在贵州具有广泛影响力的中天住宅品牌。成功开发中天花园、中天·世纪新城、中天会展城等项目，同时涵盖物业、健身、教育等产业，并且这些产业都是有口皆碑的。现在中天中天城投集团着重开发未来方舟这个超级大盘。
            </div>

            <lineconbgtir :labelcontainer="Documentedit" class="margin-top-40"></lineconbgtir>
            <p style="margin-top: 40px; text-align: start">
                本项目为线上申报，请点击下方按钮进入申报表单填报页面
            </p>
            <downinpu v-if="faile" :downlist="downlist"></downinpu>
            <el-button
                icon="el-icon-edit"
                style="
          color: #194abe;
          border: 1px solid #194abe;
          width: 189px;
          height: 50px;
          font-size: 18px;
          margin-top: 50px;
        "
                size="small"
                :disabled="false"
                @click="onSubmitTap">
                开始填写资料
            </el-button>
        </div>
        <div v-if="step === 2">
            <div v-if="isFail =='pendding'" class="shenhjrkr">
                <img src="../assets/shenhr.png" alt>
                <p style="font-size: 16px; color: #333333">待专家审核中...</p>
                <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
                    正在审核您提交的资料，请稍后查看结果
                </p>
                <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="apply_view">
                            查看申请资料
                        </el-button>
                    </div>

            </div>
            <div v-if="isFail =='distribution'" class="shenhjrkr">
                <img src="../assets/shenhr.png" alt>
                <p style="font-size: 16px; color: #333333">待分配专家...</p>
                <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
                    正在审核您提交的资料，请稍后查看结果
                </p>
                <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="apply_view">
                            查看申请资料
                        </el-button>
                    </div>

            </div>
            <div v-if="isFail == 'fail' && modifyID == 13">
                <div class="shenhjrkr">
                    <img src="../assets/faile.png" alt>
                    <p style="font-size: 20px; color: #333333">审核未通过</p>
                    <p style="font-size: 16px; color: #e51725; margin: 10px 0">
                        未通过原因：{{ reason }}
                    </p>
                    <p style="font-size: 16px; color: #9fa5ae; margin: 10px 0">
                       {{activeAward.award_id != 12 ? '请修改后重新提交' : '请重新申请'}}
                    </p>
                    <div class="flex-left" v-if="activeAward.award_id != 12">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="now_modify">
                            现在去修改
                        </el-button>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="step === 3 && modifyID == 13">
            <div v-if="isFail =='pendding'" class="shenhjrkr">
                <img src="../assets/shenhr.png" alt>
                <p style="font-size: 16px; color: #333333">待上传附件中...</p>
               <!-- <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
                    正在审核您提交的资料，请稍后查看结果
                </p> -->
                <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="Appendix(projectname,projectid)">
                            上传附件
                        </el-button>
                    </div>

            </div>
            <div v-if="isFail =='distribution'" class="shenhjrkr">
                <img src="../assets/shenhr.png" alt>
                <p style="font-size: 16px; color: #333333">待验收核查...</p>
                <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
                    正在审核您提交的附件，请稍后查看结果
                </p>
                <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="apply_view">
                            查看申请资料
                        </el-button>
                    </div>

            </div>


        </div>


        <div v-if="step === 3 && modifyID != 13">
            <div v-if="isFail == 'pendding'" class="shenhjrkr">
                <img src="../assets/shenhr.png" alt>
                <p style="font-size: 16px; color: #333333">待平台审核中</p>
                <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
                    正在审核您提交的资料，请稍后查看结果
                </p>
                <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="apply_view">
                            查看申请资料
                        </el-button>
                    </div>

            </div>
            <div v-if="isFail == 'fail'">
                <div class="shenhjrkr">
                    <img src="../assets/faile.png" alt>
                    <p style="font-size: 20px; color: #333333">审核未通过</p>
                    <p style="font-size: 16px; color: #e51725; margin: 10px 0">
                        未通过原因：{{ reason }}
                    </p>
                    <p v-if="!modifyExpired" style="font-size: 16px; color: #9fa5ae; margin: 10px 0">
                       {{activeAward.award_id != 12 && activeAward.award_id != 21 ? '请修改后重新提交' : '请重新申请'}}
                    </p>
                    <p v-else class="modify-expired">修改时间已截止</p>
                    <div class="flex-left" v-if="!modifyExpired && activeAward.award_id != 12 && activeAward.award_id != 21">
                        <el-button
                            size="small"
                            icon="el-icon-edit"
                            style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
                            class="block-submit"
                            @click="now_modify">
                            现在去修改
                        </el-button>
                    </div>
                </div>
            </div>
            <div v-if="( (isFail == 'response'&&modifyID!=13)||(isFail == 'response'&&modifyID==13&&isfile_urls) ) && activeAward.award_id != 17" class="shenhjrkr">
                <img src="../assets/failesucee.png" alt>
                <p style="font-size: 20px;color:#333333">已通过平台审核</p>
                <p style="font-size: 16px;color: #9FA5AE;margin: 10px 0">请下载您所提交资料的打印文件，打印后补充盖章、日期、签名等空缺</p>
                <div class="flex-left">
                    <el-button
                        size="small"
                        icon="el-icon-printer"
                        style="color:#194ABE;border:1px solid #194ABE;width:189px;height:50px;font-size:18px;margin-top:50px;background:#fff;margin:0 auto"
                        class="block-submit"
                        @click="downfile">
                        下载打印文件
                    </el-button>
                </div>
                <div>
                </div>
            </div>
        </div>
         <div v-if="activeAward.award_id == 17 && step > 0  && rstep == 3 && activeAward.is_show_score == 1">
                <div style="font-size:18px;font-weight:bold;">项目批次:{{activeAward.award_batch.year}}-{{activeAward.award_batch.batch}}</div>
                <table style="width:100%;">
                    <tr>
                        <th>课题名称</th>
                        <th>课题类型</th>
                        <th>评审结果</th>
                    </tr>
                    <tr>
                        <td>{{activeAward.content['project_title']}}</td>
                         <td>{{activeAward.content['project_type']}}</td>
                        <td>{{activeAward.is_out == 1 ? '淘汰' : '通过'}}</td>

                    </tr>
                </table>
            </div>

        <div v-if="step == 4 && modifyID != 13">
            <div v-if="!address">
                <div>
                    <lineconbgtir :labelcontainer="labelcontaineragain" style="margin-top: 20px"></lineconbgtir>
                    <p style="font-size: 16px;color: #9FA5AE;margin: 10px 0 0 ;text-align:start">下载打印文件并补充盖章、日期、签名后，将表单内容以电子档形式上传，提交审核后进入下一流程。</p>
                    <div class="upload">
                        <el-upload
                            class="upload-demo"
                            :action="$baseURL+'/api/home/upload/file/award_log'"
                            :on-preview="handlePreview"
                            :data="{token:token}"
                            accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
                            :on-remove="handleRemove"
                            :file-list="fileList"
                            :on-success="handleAdd"
                            :on-error="handleError"
                            list-type="text">
                            <div class="uploadheader">
                                <span>上传文件</span>
                                <el-button size="small" icon="el-icon-upload2" style="color: #194ABE">点击选择文件</el-button>
                                <span v-if="showErr" slot="tip" class="el-upload__tip margin-left-30">
                                    <i class="el-icon-error"></i>支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
                                </span>
                            </div>
                        </el-upload>
                    </div>

                    <div class="flex-left">
                        <el-button
                            size="small"
                            icon="el-icon-check"
                            style="background-color: #194ABE;color: white;margin-bottom: 20px"
                            class="block-submit"
                            @click="onSubmitTap">
                            提交专家审核
                        </el-button>
                    </div>
                </div>
            </div>

            <div v-else>
                <div class="shenhjrkr">
                    <img src="../assets/failesucee.png" alt>
                    <p style="font-size: 20px; color: #333333">项目申请成功</p>
                    <p style="font-size: 16px; color: #9fa5ae; margin: 10px 0">
                        我们会尽快将项目证书发放给您，如需修改地址请联系400-888-8888
                    </p>
                    <div class="block-addr" v-if="address">
                        <span class="span-l">已提交的收货地址：</span>
                        <span class="span-r">{{ address }}</span>
                        <!-- <el-input type="textarea" rows="5" placeholder="请输入您的收货地址" v-model="textarea" class="textarea">
            </el-input>-->
                    </div>
                </div>
            </div>
        </div>
        <div v-if="step == 4 && modifyID == 13">
            <div  class="shenhjrkr">
                <img src="../assets/failesucee.png" alt>
                <p style="font-size: 20px;color:#333333">已通过平台审核</p>
                <p style="font-size: 16px;color: #9FA5AE;margin: 10px 0">请下载您所提交资料的打印文件，打印后补充盖章、日期、签名等空缺</p>
                <div class="flex-left">
                    <el-button
                        size="small"
                        icon="el-icon-printer"
                        style="color:#194ABE;border:1px solid #194ABE;width:189px;height:50px;font-size:18px;margin-top:50px;background:#fff;margin:0 auto"
                        class="block-submit"
                        @click="downfile">
                        下载打印文件
                    </el-button>
                </div>
                <div>
                </div>
            </div>
        </div>
        <huangguoshu
            v-if="isdownload&&modifyID==9"
            :alldata="content"
            @previewDom="previewDom"></huangguoshu>
        <lvshe
            v-if="isdownload&&modifyID==13"
            :alldata="content"
            @previewDom="previewDom"></lvshe>
        <project-manager
            v-if="isdownload&&modifyID==15"
            :alldata="content"
            @previewDom="previewDom"></project-manager>
        <construction
            v-if="isdownload&&modifyID==14"
            :alldata="content"
            @previewDom="previewDom"></construction>
    </div>
</template>

<script>
import Huangguoshu from '@/components/word/preview_5.vue'
import Lvshe from '@/components/word/preview_2.vue'
import ProjectManager from '@/components/word/preview_1.vue'
import Construction from '@/components/word/preview_3.vue'
import Lineconbgtir from './Modal/Line'
import Downinpu from '@/components/Modal/Downinpu'
import Pagetion from '@/components/Modal/Pagetion'
import AllHeader from '@/components/Modal/AllHeader'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import FromProject from './fromProjcet/greenProject.vue'
import {
    submitFileHgs,
    AwardInfoList,
    DeclareDetails,
    DeclareDestory,
    WithdrawAwardLog,
    AwardList,
    AwardInfo, //申报记录详情
    AwardLog, //申报奖项
    Address, AwardListWithCount, submitFile, //填写地址
    CertificateDownload, SendDownloadSms
} from '../utils/api.js'
import { normalizeGongfaRecordState } from '../utils/gongfaEnterprise'
export default {
    name: 'DeclarRecord',
    components: {
        AllHeader,
        Pagetion,
        // Steps,
        Lineconbgtir,
        Downinpu,
        Huangguoshu,
        Lvshe,
        ProjectManager,
        Construction,
        FromProject,
    },
    data() {
        return {
            dialogUploadVisible:false,
        // 公示确认
        // 证书下载
            certDownloadVisible: false,
            dlCertRow: null,
            dlForm: { phone: '', sms_code: '' },
            dlLoading: false,
            smsCountdown: 0,
            smsTimer: null,
            projectname:'',//项目名称
            isfile_urls:null,//利用file_urls判断绿色施工是否第二次上传资料
            content: {},//表单数据
            isdownload: false,//需要下载得页面是否显示
            total: 1,
            sublabel: '返回记录列表',
            subtitle: '',
            ischage: '',
            lable: '',
            recordlist: [],
            list: [
                {
                    title: '选择项目',
                    isred: true
                },
                {
                    title: '资料上传',
                    isred: true
                },
                {
                    title: '平台审核',
                    isred: true
                },
                {
                    title: '专家审核',
                    isred: true
                },
                {
                    title: '完成',
                    isred: true
                }
            ],
            awardList: [], //奖项列表
            address: '', //收货地址
            reason: '', //审核未通过原因
            file_urls: [],
            modifyID: '',//奖项id
            showErr: false,
            isFail: 'pending', //审核状态是否失败 fail(失败) pending(审核中) response(成功)
            id: '',
            token: '',
            pageSize: 10,
            step: -1,
            rstep:-1,
            fileList: [],
            filesupplementList:[],
            textarea: '',
            labelcontainertow: {
                lable: '申请须知',
                desc: 'Application Notes'
            },
            Documentedit: {
                lable: '填写申请表单',
                desc: 'Document edit'
            },
            labelcontainerdeclare: {
                lable: '请选择您要申报的项目',
                desc: ''
            },
            labelcontainer: {
                lable: '开始上传',
                desc: 'Document download'
            },
            labelcontaineragain: {
                lable: '上传附件',
                desc: 'Upload the completed form'
            },
            labelcontainerdow: {
                lable: '申请文档下载',
                desc: 'Document download'
            },
            downlist: [
                {
                    name: '会员申请表',
                    url: 'www.baidu.com'
                },
                {
                    name: '会员申请表会员申请表会员申请表会员...',
                    url: 'www.baidu.com'
                }
            ],
            supplementName:'',//补充材料名词
            currentSupplementId:0,
            currentId:0,
            currentSubTitle:'',
            activeAward: {},
            is_show_score:0,
            projectid:0,
            baid:0,
            btitle:''
        }
    },
    computed: {
        isGroupAward() {
            console.log('this.subtitle',this.subtitle)
            return this.subtitle == '工程建设质量管理小组竞赛活动' || this.subtitle == '省级施工工法'  || this.subtitle == '贵州省工程建设工法评定' || this.subtitle == '贵州省优质工程'
        },
        operationColumnWidth() {
            if (this.currentId == 12) return '70px'
            if (this.currentId == 21) return '180px'
            return '320px'
        },
        modifyExpired() {
            if (!this.activeAward || this.activeAward.award_id != 17) return false;
            const batch = this.activeAward.award_batch || this.activeAward.awardBatch;
            const preReviewAt = batch && batch.pre_review_at;
            const checkedAt = batch && batch.checked_at;
            console.log('[modifyExpired] award_id', this.activeAward.award_id, 'pre_review_at', preReviewAt, 'checked_at', checkedAt);
            const range = Array.isArray(preReviewAt) && preReviewAt[1] ? preReviewAt : checkedAt;
            if (!Array.isArray(range) || !range[1]) return false;
            const end = new Date(range[1]).getTime();
            if (!end) return false;
            return Date.now() > end;
        },
    },
    mounted() {
        console.log('mounted')  
        this.lable = this.$route.query.name
        this.token = 'Bearer ' + localStorage.getItem('TOKEN')
        this.initList(1)
    },
    created(){
      this.baid = this.$route.query.baid;
      this.btitle = this.$route.query.btitle;
      if(this.baid){
          this.awardrecordList(1,this.baid,this.btitle)
      }
      
    },
    methods: {
        //传附件
        Appendix(name,id){
            const baid = 13
            const btitle = this.currentSubTitle || '建筑与市政工程绿色施工评价'
            this.$router.push('/member/uploadAppendix?id='+id+'&name='+name+'&baid='+baid+'&btitle='+btitle)
        },
        openUpload(id){
            this.dialogUploadVisible = true
            this.currentSupplementId = id
        },
        //下载PDF
        getPdf(ref) {
            let _this = this
            html2Canvas(ref, {
                allowTaint: true,
                useCORS: true
            }).then(function (canvas) {
                console.log(999, canvas)
                // const width = ref.offsetWidth
                // const height = ref.offsetHeight
                var context = canvas.getContext('2d')
                context.mozImageSmoothingEnabled = false
                context.webkitImageSmoothimgEnabled = false
                context.msImageSmoothingEnabled = false
                context.imageSmoothingEnabled = false
                let contentWidth = canvas.width
                let contentHeight = canvas.height
                let pageHeight = contentWidth / 592.28 * 841.89
                let leftHeight = contentHeight
                let position = 0
                let imgWidth = 595.28
                let imgHeight = 592.28 / contentWidth * contentHeight
                let pageData = canvas.toDataURL('image/jpeg/png/jpg', 1.0)
                let PDF = new JsPDF('', 'pt', 'a4')
                if (leftHeight < pageHeight) {
                    PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
                } else {
                    while (leftHeight > 0) {
                        PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                        leftHeight -= pageHeight
                        position -= 841.89
                        if (leftHeight > 0) {
                            PDF.addPage()
                        }
                    }
                }
                PDF.save(_this.subtitle + '.pdf')
                _this.isdownload = false
            })
        },
        previewDom(v) {
            this.getPdf(v)
        },
        downfile() {
            this.isdownload = true
        },
        detail(id, status, title, file_urls,content) {
            if (content&&content.info) {
                this.projectname = content.info.msg1
            }
            this.projectid = id;
            this.isfile_urls = file_urls
            this.onApplyTap(id, status, title)
        },
        isPreReviewOpen(row) {
            const batch = row && row.award_batch
                ? row.award_batch
                : (row && row.awardBatch ? row.awardBatch : null);
            const range = batch && batch.pre_review_at
                ? batch.pre_review_at
                : (batch && batch.checked_at ? batch.checked_at : null);
            const end = range ? range[1] : null;
            if (!end) return true
            let endStr = String(end)
            if (/^\d{4}-\d{2}-\d{2}$/.test(endStr)) {
                endStr = endStr + ' 23:59:59'
            }
            const endTime = Date.parse(endStr)
            if (Number.isNaN(endTime)) return false
            return Date.now() <= endTime
        },
        canResubmit(row) {
            const awardId = Number(row && row.award_id);
            const status = Number(row && row.status);
            const ok = ((awardId === 13 || awardId === 17) && status === 5) ||
                (awardId === 21 && row && row.gongfaState && row.gongfaState.canResubmit);
            if (this.$route && this.$route.query && this.$route.query.debug === '1') {
                console.info('[DeclarRecord] canResubmit', {
                    id: row && row.id,
                    award_id: row && row.award_id,
                    status: row && row.status,
                    pre_review_at: row && row.award_batch && row.award_batch.pre_review_at,
                    ok,
                });
            }
            return ok;
        },
        canWithdraw(row) {
            const awardId = Number(row && row.award_id);
            if (awardId !== 21) return false;
            // status=1 才是已提交待审核，撤回后变为0（草稿），不应再显示撤回按钮
            if (Number(row.status) !== 1) return false;
            console.log("awardId222==:"+awardId);
            // 前端直接判断申报期，不依赖后端字段
            const batch = row && row.award_batch ? row.award_batch : (row && row.awardBatch ? row.awardBatch : null);
            console.log("batch==:", batch);
            const applyAt = batch && batch.apply_at;
            console.log("applyAt==:", applyAt);
            if (!applyAt || !Array.isArray(applyAt) || applyAt.length < 2) {
                console.log("applyAt格式错误或不存在");
                return false;
            }
            const today = new Date().toISOString().slice(0, 10);
            console.log("today==:", today, "applyAt[0]==:", applyAt[0], "applyAt[1]==:", applyAt[1]);
            const result = today >= applyAt[0] && today <= applyAt[1];
            console.log("canWithdraw result==:", result);
            return result;
        },
        formatDeadline(deadline) {
            if (!deadline) return '';
            return String(deadline).slice(0, 10);
        },
        withdrawGongfa(row) {
            if (!row || !row.id) return
            // 不预先调撤回接口，直接进表单；提交时后端原子处理撤回+重提
            this.reSubmit(row)
        },
        hasGreenSupplement(fileUrls) {
            if (Array.isArray(fileUrls)) return fileUrls.length > 0
            return !!fileUrls
        },
        reSubmit(row) {
            if (!row || !row.id) return
            if (row.award_id == 13) {
                const title = row.award?.title || '建筑与市政工程绿色施工评价'
                if (this.hasGreenSupplement(row.file_urls)) {
                    this.$router.push({
                        path: '/member/uploadAppendix',
                        query: {
                            id: row.id,
                            name: title,
                            baid: 13,
                            btitle: title,
                        },
                    })
                    return
                }
                this.$router.push({
                    path: '/form',
                    query: {
                        title,
                        id: row.award_id,
                        r: row.id,
                        award_batch_id: row.award_batch_id,
                    },
                })
                return
            }
            this.$router.push(`/form?title=${row.award?.title || ''}&id=${row.award_id}&r=${row.id}&award_batch_id=${row.award_batch_id}`)
        },
        edit(id,created_at){
            if(Date.parse(created_at) < Date.parse('2023-10-19')){
                this.$message.error('该申报已结束，不可修改！')
                return false
            }
            this.$router.push('/form?title=省级施工工法&id=12&a_id='+id)
        },
        openLog(row) {
            if (!row) return
            const title = row.award && row.award.title ? row.award.title : '申报记录'
            this.$router.push({
                path: '/gflogs',
                query: {
                    title,
                    awardid: row.award_id,
                    logid: row.id,
                    award_batch_id: row.award_batch_id,
                },
            })
        },
        openGongfaDetail(row) {
            if (!row) return
            const title = row.award && row.award.title ? row.award.title : '申报记录'
            this.$router.push(`/word_1?id=${row.id}&awardid=${row.award_id}&awardbatchid=${row.award_batch_id}&title=${encodeURIComponent(title)}&is_view=1`)
        },
        destory(id){
            DeclareDestory(id).then((res) => {
                this.$message.success('删除成功')
                this.awardrecordList(1)
            }).catch(err => {
                console.log(err)
                this.$message.error(err)
            })
        },
        //申报奖项记录列表
        async awardrecordList(page,award_id,title){
            if(award_id){
                this.currentId = award_id
                this.currentSubTitle = title
            }
            const data = {
                page_size: this.pageSize,
                page: page,
                award_id:this.currentId
            }
            this.lable = this.$route.query.name
            let res = await AwardInfoList(data)
            console.log(987, res)
            this.step = 0
            this.ischage = true
            this.subtitle = this.currentSubTitle
            this.total = res.total
            res.data.forEach((element) => {
                element.created_at = element.created_at.replace(/\s[\x00-\xff]*/g, '')
                element.year = element.created_at.substring(0,4)
                if(element.award_id == 21){
                    element.gongfaState = normalizeGongfaRecordState(element)
                    if (element.status == 1) {
                        element.statustext = '待分配专家'
                        element.operation = '详情'
                    }
                    if (element.status == 2) {
                        element.statustext = '待初审'
                        element.operation = '详情'
                    }
                    if (element.status == 3) {
                        element.statustext = '待中审'
                        element.operation = '详情'
                    }
                    if (element.status == 4) {
                        element.statustext = '待终审'
                        element.operation = '详情'
                    }
                    if (element.status == 5) {
                        element.statustext = '审核通过'
                        element.operation = '详情'
                    }
                    if (element.status == 6) {
                        element.statustext = '审核不通过'
                        element.operation = '详情'
                    }
                    if (element.status == 7) {
                        element.statustext = '驳回重新修订'
                        element.operation = '详情'
                    }
                } else if(element.award_id == 17) {
                    if (element.status == 1) {
                        element.statustext = '待分配专家'
                        element.operation = '详情'
                    }
                    if (element.status == 2) {
                        element.statustext = '待专家评分'
                        element.operation = '详情'
                    }
                    if (element.status == 3) {
                        element.statustext = '待初审'
                        element.operation = '详情'
                    }
                    if (element.status == 4) {
                        element.statustext = '审核完成'
                        element.operation = '详情'
                    }
                    if (element.status == 5) {
                        element.statustext = '审核不通过'
                        element.operation = '详情'
                    }
                    // 工程建设质量管理小组竞赛活动：整合公示状态
                    if (element.status != 5 && element.has_pending_modify) {
                        element.statustext = '申请修改'
                    } else if (element.status != 5 && element.publicity_status === 6) {
                        element.statustext = '待企业确认'
                    } else if (element.status != 5 && element.publicity_status === 7) {
                        element.statustext = element.is_out == 1 ? '审核完成' : '企业已确认'
                    } else if (element.status != 5 && element.publicity_status === 8) {
                        element.statustext = '已发证'
                    }
                } else if(element.award_id == 13) {
                    if (element.status == 1) {
                        element.statustext = '待分配专家'
                        element.operation = '详情'
                    }
                    if (element.status == 2) {
                        element.statustext = '待专家审核'
                        element.operation = '详情'
                    }
                    if (element.status == 3) {
                        element.statustext = '待平台审核'
                        element.operation = '详情'
                    }
                    if (element.status == 4) {
                        element.statustext = Number(element.supplement_checked) === 1 ? '审核通过' : '初审通过'
                        element.operation = '详情'
                    }
                    if (element.status == 5) {
                        element.statustext = element.file_urls ? '审核不通过' : '初审不通过'
                        element.operation = '详情'
                    }
                    // 贵州省建筑业绿色施工评价：合并公示状态
                    if (element.status != 5 && element.has_pending_modify) {
                        element.statustext = '申请修改'
                    } else if (element.status != 5 && element.publicity_status === 6) {
                        element.statustext = '待企业确认'
                    } else if (element.status != 5 && element.publicity_status === 7) {
                        element.statustext = '企业已确认'
                    } else if (element.status != 5 && element.publicity_status === 8) {
                        element.statustext = '已发证'
                    }
                } else {
                    if (element.status == 1) {
                        element.statustext = '待分配专家'
                        element.operation = '详情'
                    }
                    if (element.status == 2) {
                        element.statustext = '待专家审核'
                        element.operation = '详情'
                    }
                    if (element.status == 3) {
                        element.statustext = '待平台审核'
                        element.operation = '详情'
                    }
                    if (element.status == 4) {
                        element.statustext = '审核通过'
                        element.operation = '详情'
                    }
                    if (element.status == 5) {
                        element.statustext = '审核不通过'
                        element.operation = '详情'
                    }
                }
                
            })
            this.recordlist = res.data
        },
        //奖项列表
        async initList(page) {
            const data = {
                page_size: this.pageSize,
                page: page
            }
            let res = await AwardListWithCount(data)
            this.awardList = res.data || []
        },
        async awardExport(){
            let url = `${window.location.protocol}//${window.location.host}/api/home/user/award_log/export/${this.activeAward.id}?token=${this.token}`;
             console.log(url)
             window.open(url);
        },
        // 去申请查看申请信息
        async onApplyTap(id, status, title) {
            if (status) {
                DeclareDetails(id)
                    .then((res) => {
                        this.activeAward = res
                        this.content = res.content
                        if(res.award_id == 17){
                            this.list= [
                                {
                                    title: '资料上传',
                                    isred: true
                                },
                                {
                                    title: '平台审核',
                                    isred: true
                                },
                                {
                                    title: '专家评审',
                                    isred: true
                                },
                                {
                                    title: '完成',
                                    isred: true
                                }
                            ];
                            this.id = res.id
                            this.modifyID = res.award_id
                            if (res.status == 5) {
                                //审核不通过
                                this.step = 3
                                this.rstep = 1
                                this.isFail = 'fail'
                                this.reason = res.reject_reason || ''
                            }
                            if (res.status == 4) {
                                //审核完成
                                this.step = 3
                                this.rstep = 3
                                this.isFail = 'pendding'
                                this.address = res.address || ''
                            }
                            if (res.status == 3) {
                                //待平台审核
                                this.step = 3
                                this.rstep = 1
                                this.isFail = 'pendding'
                                this.reason = res.reject_reason || ''
                            }
                            if (res.status == 2) {
                                //待专家审核
                                this.step = 2
                                this.rstep = 2
                                this.isFail = 'pendding'
                                this.address = res.address || ''
                            }
                            if (res.status == 1) {
                                //待分配专家
                                this.step = 2
                                this.rstep = 1
                                this.isFail = 'distribution'
                                this.reason = res.reject_reason || ''
                            }
                            if( res.score > 0 && res.is_show_score == 1){
                                this.step = 3
                                this.rstep = 3;
                                this.isFail = 'response'
                            }
                            console.log('res.score ',res.score )
                            console.log('res.rsetp',this.rstep)
                            console.log('res.is_show_score',res.is_show_score)

                        } else if(res.award_id == 13){
                            console.log('res.award_id ',res.award_id )
                            console.log('res.status ',res.status )
                            this.list= [
                                {
                                    title: '资料上传',
                                    isred: true
                                },
                                {
                                    title: '平台审核',
                                    isred: true
                                },
                                {
                                    title: '验收评价',
                                    isred: true
                                },
                                {
                                    title: '完成',
                                    isred: true
                                }
                            ];
                            this.id = res.id
                            this.modifyID = res.award_id
                            if (res.status == 5 && res.file_urls == null) {
                                //审核不通过
                                this.step = 2
                                this.rstep = 1
                                this.isFail = 'fail'
                                this.reason = res.reject_reason || ''
                            }
                            console.log('res.file_urls',res.file_urls );
                            if (res.status == 4 && res.file_urls == null) {
                                //审核通过
                                this.step = 3
                                this.rstep = 2
                                this.isFail = 'pendding'
                                this.address = res.address || ''
                            }
                            if (res.status == 3) {
                                //待平台审核
                                this.step = 2
                                this.rstep = 1
                                this.isFail = 'pendding'
                                this.reason = res.reject_reason || ''
                            }
                            if (res.status == 3 && res.file_urls != null) {
                                //待平台审核
                                this.step = 3
                                this.rstep = 2
                                this.isFail = 'distribution'
                                this.reason = res.reject_reason || ''
                            }
                            if (res.status == 4 && res.file_urls) {
                                //待平台审核
                                this.step = 4
                                this.rstep = 3
                                this.isFail = 'distribution'
                                this.address = res.address || ''
                                console.log('this.address',this.address)
                                //this.reason = res.reject_reason || ''
                            }
                            if (res.status == 5 && res.file_urls) {
                                //待平台审核
                                this.step = 2
                                this.rstep = 2
                                this.isFail = 'fail'
                                this.reason = res.reject_reason || ''
                                //this.reason = res.reject_reason || ''
                            }
                            // if (res.status == 2) {
                            //     //待专家审核
                            //     this.step = 2
                            //     this.rstep = 2
                            //     this.isFail = 'pendding'
                            //     this.address = res.address || ''
                            // }
                            // if (res.status == 1) {
                            //     //待分配专家
                            //     this.step = 2
                            //     this.rstep = 1
                            //     this.isFail = 'distribution'
                            //     this.reason = res.reject_reason || ''
                            // }
                            if( res.score > 0 && res.is_show_score == 1){
                                this.step = 3
                                this.rstep = 3;
                                this.isFail = 'response'
                            }
                            console.log('res.step',this.step)
                            console.log('res.isFail ',this.isFail )
                            console.log('res.rsetp',this.rstep)
                            console.log('res.is_show_score',res.is_show_score)

                        } else  if (res.award_id) {
                            this.id = res.id
                            this.modifyID = res.award_id
                            if (res.status == 5) {
                                //审核不通过
                                this.step = 3
                                this.isFail = 'fail'
                                this.reason = res.reject_reason || ''
                            }
                            if (res.status == 4) {
                                //审核通过
                                this.step = 3
                                this.isFail = 'response'
                                this.address = res.address || ''
                            }
                            if (res.status == 3) {
                                //待平台审核
                                this.step = 3
                                this.isFail = 'pendding'
                                this.reason = res.reject_reason || ''
                            }
                            if (res.status == 2) {
                                //待专家审核
                                this.step = 2
                                this.isFail = 'pendding'
                                this.address = res.address || ''
                            }
                            if (res.status == 1) {
                                //待分配专家
                                this.step = 2
                                this.isFail = 'distribution'
                                this.reason = res.reject_reason || ''
                            }
                        }

                        //  else {
                        //   //去填写资料
                        //   this.step = 1;
                        //   this.ischage = false;
                        //   this.id = id;
                        // }
                        this.ischage = true
                        this.subtitle = title
                    })
                    .catch((err) => {
                        this.$message.error(err)
                    })
            }
        },
        handleAdd(response, file, fileList) {
            this.setUrls(fileList)
        },
        handleRemove(file, fileList) {
            this.setUrls(fileList)
        },
        handlePreview(file) {
        },
        handlesupplementAdd(response, file, fileList) {
            this.filesupplementList = fileList
            console.log(this.filesupplementList,'handlesupplementAdd')
        },
        handlesupplementRemove(file, fileList) {
            this.filesupplementList=[]
            console.log(this.filesupplementList,'handlesupplementRemove')
        },
        handlesupplementPreview(file) {
        },
        handlesupplementError(){
        },
        //获取上传数组
        setUrls(fileList) {
            let urls = []
            fileList.map((item) => {
                urls.push(item.response.data.host + item.response.data.url)
            })
            this.file_urls = urls
            console.log(this.file_urls)
        },
        handleError(err, file, fileList) {
            this.showErr = true
            let that = this
            setTimeout(function () {
                that.showErr = false
                console.log(that.showErr)
            }, 2000)
            // console.log(this.showErr);
        },
        //现在去修改
        now_modify() {
            if (this.isFail == 'fail'&&this.modifyID == 13&&this.hasGreenSupplement(this.isfile_urls)) {
                const btitle = this.subtitle || '建筑与市政工程绿色施工评价'
                this.$router.push({
                    path: '/member/uploadAppendix',
                    query: {
                        id: this.id,
                        name: this.subtitle,
                        baid: 13,
                        btitle,
                    },
                })
                return false
            }
            this.$router.push({
                path: '/form',
                query: {
                    title: this.subtitle,
                    id: this.modifyID,
                    r: this.id,
                    award_batch_id: this.activeAward.award_batch_id,
                },
            })
        },
        apply_view(){
            this.$router.push(`/word_1?id=${this.id}&awardid=${this.modifyID}&awardbatchid=${this.activeAward.award_batch_id}&title=${this.subtitle}&is_view=1`);
        },
        // 提交审核
        onSubmitTap() {
            // this.$router.push(`/form?title=${this.subtitle}&id=${this.id}`);
            if (this.file_urls.length && this.id) {
                const data = {
                    award_id: this.id,
                    file_urls: this.file_urls
                }
                AwardLog(data).then(res => {
                    console.log(res)
                    this.step = 3
                    this.isFail = false
                })
            } else {
                this.$message({
                    message: '请上传文档',
                    type: 'warning'
                })
            }
        },
        // 提交地址
        async onAddressTap() {
            if (this.textarea) {
                let id = this.id
                let addr = this.textarea

                Address(id, addr)
                    .then((res) => {
                        this.address = addr
                    })
                    .catch((err) => {
                        this.$message.error(err.response.data.message)
                    })
            } else {
                this.$message.warning('请填写地址')
            }
        },
        getvalue() {
            console.log(this.step)
            if(this.step==0){
                this.step = -1
                this.ischage = false
                this.subtitle = ''
            }
            else{
                this.step = 0
            }
        },

        getpageValue(index) {
            // console.log(index);
            // this.initList(index);
            this.awardrecordList(index)
        },
        greenPorject(v,is){
            console.log(v,is)
        },
        handleClose(done){
            this.supplementName = ''
            this.filesupplementList = []
            done()
        },
        supplementClose(){
            this.dialogUploadVisible = false
            this.supplementName = ''
            this.filesupplementList = []
        },
        supplementSubmit(){
            if(!this.supplementName){
                this.$message.error('请输入材料名词')
                return
            }
            if(this.filesupplementList.length<=0){
                this.$message.error('请上传附件')
                return
            }
            const data = {
                file_urls:this.supplementName+','+this.filesupplementList[0].response.data.host+this.filesupplementList[0].response.data.url
            }
            let that = this
            submitFileHgs(data, this.currentSupplementId).then((res) => {
                console.log(res)
                if (res) {
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    })
                    that.dialogUploadVisible = false
                    that.supplementName = ''
                    that.filesupplementList = []
                }else{
                    this.$message({
                        type: 'error',
                        message: '保存失败'
                    })
                }
            })
        },

        goPublicity(row) {
            if (!row || !row.id) return
            this.$router.push({
                path: '/member/publicity_confirm',
                query: { log_id: row.id },
            })
        },

        // ========== 证书下载 ==========
        openCertDownload(row) {
            const certId = row && row.certificate_id
            if (!certId) {
                this.$message.error('该记录暂无对应证书')
                return
            }
            this.$router.push({
                path: '/member/certificates/download',
                query: {
                    cert_id: certId,
                    award_id: row.award_id,
                    award_title: row.award?.title || row.award_title || '',
                    name: '荣誉证书明细',
                },
            })
        },
        sendDlSms() {
            if (!this.dlForm.phone || this.dlForm.phone.length !== 11) {
                this.$message.warning('请输入正确的手机号')
                return
            }
            const certId = this.dlCertRow && this.dlCertRow.certificate_id
            if (!certId) {
                this.$message.error('证书信息缺失')
                return
            }
            SendDownloadSms(this.dlForm.phone, certId).then(() => {
                this.$message.success('验证码已发送')
                this.smsCountdown = 60
                this.smsTimer = setInterval(() => {
                    this.smsCountdown--
                    if (this.smsCountdown <= 0) clearInterval(this.smsTimer)
                }, 1000)
            }).catch(err => this.$message.error(err || '发送失败'))
        },
        async doCertDownload() {
            if (!this.dlForm.phone || !this.dlForm.sms_code) {
                this.$message.warning('请填写手机号和验证码')
                return
            }
            this.dlLoading = true
            try {
                // 找到该申报记录对应的证书 id
                const certId = this.dlCertRow && this.dlCertRow.certificate_id
                if (!certId) {
                    this.$message.error('该记录暂无对应证书')
                    return
                }
                // 先校验短信验证码，成功后再触发下载
                await CertificateDownload(certId, {
                    phone: this.dlForm.phone,
                    sms_code: this.dlForm.sms_code,
                })
                let baseURL = process.env.NODE_ENV === 'development' ? 'https://test-dev.welamp.cn/api/home' : '/api/home'
                const form = document.createElement('form')
                form.method = 'POST'
                form.action = `${baseURL}/certificate/download/${certId}`
                form.target = '_blank'
                ;[
                    ['phone', this.dlForm.phone],
                    ['sms_code', this.dlForm.sms_code],
                ].forEach(([name, value]) => {
                    const inp = document.createElement('input')
                    inp.type = 'hidden'; inp.name = name; inp.value = value
                    form.appendChild(inp)
                })
                document.body.appendChild(form)
                form.submit()
                document.body.removeChild(form)
                this.certDownloadVisible = false
            } catch (e) {
                this.$message.error(e || '验证码错误或已过期')
            } finally {
                this.dlLoading = false
            }
        },
    }
}
</script>

<style>
.el-table .cell {
  width: max-content;
}
.operation-btns .el-button {
  margin-right: 4px;
}
.operation-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.operation-btns--nowrap {
  flex-wrap: nowrap;
  align-items: center;
}
.gongfa-record-hints {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
.withdraw-btn {
  background-color: #fff !important;
  color: #F56C6C !important;
  border-color: #F56C6C !important;
}
.withdraw-btn:hover {
  background-color: #F56C6C !important;
  color: #fff !important;
}
</style>
<style lang="less" scoped>
.applybut {
  padding: 6px 15px;
}
/deep/.block-title {
  border-left: 3px solid #194abe !important;
}
/deep/.el-upload-list{
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  text-align: start;
  height: auto;
}

.modify-expired {
  font-size: 18px;
  color: #e51725;
  margin: 10px 0;
  font-weight: 600;
}

.textarea {
  width: 382px;
  // height: 92px;
  background: #ffffff;
  border: 1px solid #bdc3cb;
  opacity: 1;
  border-radius: 4px;
}

.block-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0;

  &-item {
    width: 370px;
    background: #ffffff;
    border: 1px dashed #c8cdd5;
    padding: 24px 25px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 21px;
    position: relative;
    &-r-t {
      position: absolute;
      top: 0;
      right: 0;
      width: 73px;
      height: 27px;
      background: #f5f9fb;
      opacity: 1;
      border-radius: 0px 0px 0px 80px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 27px;
      color: #c6c9ce;
      padding-left: 10px;
      box-sizing: border-box;
    }
    &-box {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: flex-start;
      &-t {
        width: 244px;
        color: #0c0d0f;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align: justify;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
      &-dtae {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 26px;
        color: #194abe;
      }
      &-startend {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #7c828a;
          margin-top:10px;
      }
      &-b {
        width: 91px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #194abe;
        color: #194abe;
        opacity: 1;
        border-radius: 6px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        cursor: pointer;
      }

      &-b-d {
        background: #ffffff !important;
        border: 1px solid #d4dbdd !important;
        color: #c8cdd5 !important;
      }

      &-b-s {
        background: #d4dbdd !important;
        border: 1px solid #d4dbdd !important;
        color: #ffffff !important;
      }
    }
  }
}

.margin-bottom-40 {
  margin-bottom: 40px;
}

.infor {
  padding-bottom: 40px;
  min-height: 800px;
  margin-bottom: 34px;
  position: relative;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.upload-demo2{
    justify-content: flex-start;
    align-items: flex-start;
    width:480px;
}
.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.margin-top-40 {
  margin-top: 40px;
}

.block-solid {
  width: 100%;
  height: 2px;
  background-color: #e51725;
  margin-top: 30px;
}

.shenhjrkr {
  margin: 71px 0 100px 0;

  img {
    width: 120px;
  }
}

.stepContainer {
  width: 100%;
  height: 160px;
  background-color: #f6f6f6;
  margin: 20px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;

  .stepcone {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .stepItem {
      width: 50px;
      height: 50px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #9fa5ae;
      border: 1px solid #9fa5ae;
      font-size: 32px;
      font-weight: 900;
      color: #c8cdd5;
      z-index: 999;

      .downpng {
        position: absolute;
        top: -20px;
        width: 20px;
        height: auto;
      }
    }

    img {
      width: 27px;
      height: auto;
    }

    .isactibe {
      color: white;
      // border: 1px solid #9FA5AE;
      // background-color: #9FA5AE;
    }

    .stponce {
      color: #194abe;
      border: 1px solid #194abe;
      background-color: white;
    }

    .error {
      color: #e51725;
      border: 1px solid #e51725;
      background-color: white;
    }

    .stepTitle {
      font-size: 18px;
      color: #c8cdd5;
      margin-top: 10px;
    }

    .successtitle {
      color: #0c0d0f;
    }

    .stpotitle {
      color: #194abe;
    }

    .erroritem {
      color: #e51725;
    }

    .line {
      width: 350%;
      flex: 1;
      flex-shrink: 0;
      height: 2px;
      border-bottom: 1px dashed #d4dbdd;
      position: absolute;
      top: 25px;
      left: 85%;
    }
  }
}
.block-addr {
  display: inline-block;
  padding: 13px 32px;
  background-color: #fff7e8;
  font-size: 14px;
  margin-top: 31px;
  .span-l {
    color: #9fa5ae;
  }
  .span-r {
    color: #194abe;
  }
}
.form_1 .form_box_content .form_title{
    box-sizing: border-box;
    text-align: start;
    display: flex;
    align-items: center;
}
.my_form2, .my_form{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: visible;
    align-items: stretch;
}
.my_form2 .form_title,  .my_form .form_title{
    background: #eaf0f6;
    width: 129px;
    min-width: 129px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    padding: 6px;
    box-sizing: border-box;
    color: #0c0d0f;
}
.my_form2 .form_long,.my_form .form_long{
    width: 700px;
    padding: 0 6px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.my_form2 .form_long input, .my_form .form_long input{
    width: 488px;
    height: 36px;
    background: #fff;
    border: 1px solid #bdc3cb;
    opacity: 1;
    border-radius: 4px;
    padding: 0 15px;
    box-sizing: border-box;
}
.my_form2 .form_title {
    background: #f5f8fb;
}
.my_form2 .form_long{
    background: #fbfdff;
}

</style>
